/*
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-28 10:25:41
 */
/*
 * @description: uuid生成工具
 * @author: Jason Wong
 * @desc: used to generate random string
 */

const UUID_LENGTH = 32;
const CHARS = "0123456789abcdefghijklmnopqrstuvwxyz";

function randChar(length) {
  var res = "";
  for (var i = 0; i < length; i++) {
    res += CHARS[Math.floor(Math.random() * CHARS.length)];
  }
  return res;
}

class UUIDCreater {
  constructor(params) {
    this._length = params && params.length ? params.length : 16;
    if (this._length < 16) this._length = 16;
  }

  create() {
    var timePart = Date.now()
      .toString(16)
      .toString();
    return randChar(this._length - timePart.length) + timePart;
  }
}

/**
 * @description: 
 * @param {number} length of random string
 * @return random string
 */
export function uuid(length) {
  var res = new UUIDCreater({ length: length }).create();
  return res;
}